import { ManufacturerMonitorData, SoundLevel } from "@/models";
import {
  GetLexeonDeviceDataResponseApiDto,
  ManufacturerMonitorDataDTO,
  SoundLevelDTO,
} from "../dtos";

const mapSoundLevelDTOToSoundLevel = (soundLevelDTO: SoundLevelDTO): SoundLevel => {
  return {
    createdAt: soundLevelDTO.createdAt,
    level: soundLevelDTO.level,
  };
};

const mapManufacturerMonitorDataDTOToManufacturerMonitorData = (
  manufacturerMonitorDataDTO: ManufacturerMonitorDataDTO
): ManufacturerMonitorData => {
  return {
    monitorId: manufacturerMonitorDataDTO.monitorId,
    name: manufacturerMonitorDataDTO.name,
    batteryMode: manufacturerMonitorDataDTO.batteryMode,
    batteryLevel: manufacturerMonitorDataDTO.batteryLevel,
    firmware: manufacturerMonitorDataDTO.firmware,
    updatedAt: manufacturerMonitorDataDTO.updatedAt,
    level: manufacturerMonitorDataDTO.level,
    humidity: manufacturerMonitorDataDTO.humidity,
    iaq: manufacturerMonitorDataDTO.iaq,
    iaqAccuracy: manufacturerMonitorDataDTO.iaqAccuracy,
    temperature: manufacturerMonitorDataDTO.temperature,
    voc: manufacturerMonitorDataDTO.voc,
    sounds: manufacturerMonitorDataDTO.sounds.map(mapSoundLevelDTOToSoundLevel),
    qcPass: manufacturerMonitorDataDTO.qcPass,
  };
};

export const mapLexeonDeviceDataDTOToManufacturerMonitorData = (
  lexeonDeviceDataDTO: GetLexeonDeviceDataResponseApiDto
): ManufacturerMonitorData[] => {
  return lexeonDeviceDataDTO.data.map(mapManufacturerMonitorDataDTOToManufacturerMonitorData);
};
